<template>
  <div class="relative h-full flex flex-col justify-start dark:bg-[#1c1c1d] bg-white">
    <!-- Top fixed content -->
    <ion-list lines="none" class="cursor-pointer select-none pt-5 space-y-4 menu-list list-view flex-shrink-0 mr-4">
      <ion-item @click="logoClick" :class="loading ? 'animate-pulse' : ''" class="menu-item mr-2">
        <div class="logo-narrow">
          <svg width="90" height="24" viewBox="0 0 90 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M87.8897 7.96971C87.9789 7.92011 88.0534 7.85067 88.1129 7.7614C88.1724 7.67212 88.2021 7.56301 88.2021 7.43902C88.2021 7.31503 88.1724 7.21087 88.1178 7.12656C88.0583 7.04224 87.9889 6.97777 87.8996 6.93313C87.8103 6.88849 87.721 6.86865 87.6318 6.86865H86.7539V8.69878H87.0763V8.03914H87.5822L87.9244 8.69878H88.2815L87.8897 7.96971ZM87.0713 7.11664H87.5326C87.6119 7.11664 87.6863 7.14144 87.7508 7.19103C87.8202 7.24063 87.85 7.32495 87.85 7.43902C87.85 7.55309 87.8153 7.63741 87.7508 7.69692C87.6814 7.75644 87.607 7.7862 87.5227 7.7862H87.0664V7.11168L87.0713 7.11664Z"
              fill="#E50038" />
            <path
              d="M89.2585 7.03739C89.1544 6.79933 89.0155 6.58606 88.832 6.40255C88.6485 6.21904 88.4401 6.08017 88.1971 5.97602C87.9591 5.87186 87.7012 5.82227 87.4234 5.82227C87.1457 5.82227 86.8927 5.87186 86.6497 5.97602C86.4116 6.08017 86.1984 6.21904 86.0149 6.40255C85.8313 6.58606 85.6925 6.79437 85.5883 7.03739C85.4842 7.27546 85.4346 7.53336 85.4346 7.81111C85.4346 8.08885 85.4842 8.34179 85.5883 8.58482C85.6925 8.82289 85.8313 9.03615 86.0149 9.21966C86.1984 9.40317 86.4067 9.54204 86.6497 9.6462C86.8927 9.75035 87.1457 9.79995 87.4234 9.79995C87.7012 9.79995 87.9541 9.75035 88.1971 9.6462C88.4352 9.54204 88.6485 9.40317 88.832 9.21966C89.0155 9.03615 89.1544 8.82785 89.2585 8.58482C89.3627 8.34675 89.4123 8.08885 89.4123 7.81111C89.4123 7.53336 89.3627 7.28042 89.2585 7.03739ZM88.822 8.6245C88.6782 8.86752 88.4798 9.06591 88.2368 9.20974C87.9938 9.35357 87.721 9.42797 87.4234 9.42797C87.1258 9.42797 86.853 9.35357 86.61 9.20974C86.367 9.06591 86.1686 8.86752 86.0248 8.6245C85.8809 8.38147 85.8065 8.10869 85.8065 7.81111C85.8065 7.51353 85.8809 7.24074 86.0248 6.99771C86.1686 6.75469 86.367 6.5563 86.61 6.41247C86.853 6.26864 87.1258 6.19424 87.4234 6.19424C87.721 6.19424 87.9938 6.26864 88.2368 6.41247C88.4798 6.5563 88.6782 6.75469 88.822 6.99771C88.9659 7.24074 89.0403 7.51353 89.0403 7.81111C89.0403 8.10869 88.9659 8.38147 88.822 8.6245Z"
              fill="#E50038" />
            <path
              d="M24.0133 23.8016C22.8924 23.8016 21.8955 23.6032 21.0176 23.2114C20.1397 22.8196 19.4504 22.2344 18.9395 21.4606C18.4336 20.6869 18.1807 19.7198 18.1807 18.5592C18.1807 17.5822 18.3592 16.7638 18.7163 16.0992C19.0734 15.4346 19.5644 14.9039 20.1794 14.4972C20.7994 14.0955 21.4987 13.788 22.2923 13.5846C23.0809 13.3763 23.9091 13.2325 24.782 13.1482C25.8037 13.044 26.627 12.9399 27.252 12.8456C27.8769 12.7514 28.3332 12.6076 28.6109 12.4191C28.8887 12.2306 29.0325 11.9479 29.0325 11.571V11.5016C29.0325 10.7774 28.8044 10.217 28.353 9.82022C27.9017 9.42344 27.2569 9.22505 26.4237 9.22505C25.5458 9.22505 24.8465 9.41848 24.3307 9.80038C23.9389 10.093 23.6463 10.4402 23.4528 10.8419C23.3388 11.08 23.1007 11.2288 22.8378 11.2089L19.5396 10.9411C19.1379 10.9064 18.8701 10.5047 18.999 10.1228C19.252 9.36889 19.6339 8.69932 20.1397 8.10912C20.8093 7.32549 21.6773 6.72536 22.7436 6.30379C23.805 5.88221 25.0399 5.66895 26.4435 5.66895C27.4206 5.66895 28.358 5.78302 29.2507 6.01117C30.1484 6.23931 30.942 6.59641 31.6413 7.0775C32.3406 7.55859 32.8911 8.1736 33.2929 8.92251C33.6946 9.67143 33.898 10.5741 33.898 11.6156V21.3168C33.898 22.5071 32.9358 23.4693 31.7455 23.4693H29.8955C29.5533 23.4693 29.2755 23.1916 29.2755 22.8494V21.0341H29.1366C28.8539 21.5846 28.477 22.0657 28.0058 22.4823C27.5347 22.899 26.9643 23.2213 26.2997 23.4544C25.6351 23.6875 24.8713 23.8016 23.9984 23.8016H24.0133ZM25.407 20.4389C26.1212 20.4389 26.756 20.2951 27.3065 20.0124C27.857 19.7297 28.2885 19.3379 28.601 18.8518C28.9135 18.3658 29.0722 17.8103 29.0722 17.1953V15.3304C28.9184 15.4296 28.7101 15.5189 28.4472 15.5983C28.1844 15.6776 27.8868 15.752 27.5595 15.8165C27.2321 15.881 26.9048 15.9405 26.5774 15.9901C26.2501 16.0397 25.9525 16.0843 25.6847 16.119C25.1143 16.2034 24.6134 16.3373 24.1869 16.5208C23.7603 16.7043 23.428 16.9473 23.19 17.2598C22.9519 17.5722 22.8378 17.9492 22.8378 18.4104C22.8378 19.075 23.0809 19.5809 23.5619 19.9281C24.048 20.2753 24.663 20.4489 25.4119 20.4489L25.407 20.4389Z"
              fill="#E50038" />
            <path
              d="M52.7248 4.30531V22.8546C52.7248 23.1919 52.4521 23.4696 52.1098 23.4696H48.7422C48.4049 23.4696 48.1322 23.1968 48.1272 22.8645L47.8594 0.650005C47.8594 0.317705 48.1272 0.0449219 48.4595 0.0449219C50.8154 0.0449219 52.7248 1.95441 52.7248 4.31027V4.30531Z"
              fill="#E50038" />
            <path
              d="M70.2677 15.9311C70.7141 15.9311 71.0761 15.5691 71.0761 15.1227V14.592C71.0761 13.0991 70.8678 11.7898 70.4462 10.6738C70.0247 9.55792 69.4394 8.63045 68.6905 7.8865C67.9416 7.1475 67.0637 6.59201 66.0619 6.22004C65.06 5.84806 63.9788 5.66455 62.8182 5.66455C61.0922 5.66455 59.5944 6.04645 58.3148 6.81024C57.0352 7.57404 56.0482 8.63541 55.3439 9.99933C54.6446 11.3632 54.2925 12.9504 54.2925 14.7557C54.2925 16.561 54.6446 18.2126 55.3439 19.5666C56.0433 20.9206 57.0451 21.9671 58.3446 22.7011C59.644 23.4352 61.1964 23.8071 63.0067 23.8071C64.4549 23.8071 65.7345 23.584 66.8455 23.1376C67.9565 22.6912 68.8641 22.0663 69.5684 21.2628C69.9899 20.7817 70.3222 20.256 70.5752 19.6757C70.8281 19.0954 70.4115 18.3961 69.7568 18.3515L67.0984 18.1779C66.7413 18.1531 66.4041 18.3316 66.2206 18.6391C66.0817 18.8673 65.918 19.0756 65.7296 19.2591C65.4072 19.5616 65.0253 19.7947 64.5739 19.9435C64.1226 20.0973 63.6266 20.1717 63.086 20.1717C62.2677 20.1717 61.5634 19.9981 60.9682 19.6559C60.3731 19.3137 59.9118 18.8226 59.5894 18.1928C59.2671 17.5579 59.1034 16.809 59.1034 15.9411V15.9311H70.2627H70.2677ZM60.9335 9.81582C61.4989 9.47856 62.1536 9.30497 62.8976 9.30497C63.6415 9.30497 64.2317 9.45872 64.7674 9.76622C65.303 10.0737 65.7246 10.5003 66.0321 11.0409C66.3346 11.5815 66.4884 12.2014 66.4884 12.9057H59.1232C59.153 12.2758 59.3067 11.6955 59.6043 11.1748C59.9267 10.6044 60.3681 10.1531 60.9385 9.81582H60.9335Z"
              fill="#E50038" />
            <path
              d="M1.11004 23.995C3.4907 23.995 5.42002 22.0657 5.42002 19.6851V4.34966H9.1398C12.0015 4.34966 13.4547 5.47551 13.4547 7.69746C13.4547 9.9194 12.0015 11.0453 9.1398 11.0453H7.45846C7.39399 11.0453 7.32951 11.0552 7.26503 11.075C6.99225 11.1692 6.83354 11.4222 6.84842 11.6851C6.95753 13.8227 8.75294 15.256 11.3221 15.256C12.5124 15.256 13.7275 14.9535 14.8335 14.3831C17.0654 13.2275 18.3996 10.7278 18.3996 7.69746C18.3996 2.95102 14.9129 0 9.30843 0H3.75852C1.95815 0 0.5 1.45815 0.5 3.25852V23.39C0.5 23.7272 0.772782 24 1.11004 24V23.995Z"
              fill="#E50038" />
            <path
              d="M38.2431 6.9191C38.2034 6.9439 38.1687 6.96374 38.1291 6.98854C38.0447 7.04806 37.9604 7.10757 37.8761 7.17205C37.8216 7.21173 37.772 7.2514 37.7174 7.29108C37.643 7.3506 37.5736 7.41507 37.5041 7.47459C37.4496 7.52419 37.3901 7.57378 37.3355 7.62834C37.271 7.69282 37.2115 7.75729 37.147 7.82177C37.0925 7.88128 37.033 7.94576 36.9784 8.00528C36.9238 8.06975 36.8693 8.13919 36.8147 8.21358C36.7602 8.28302 36.7106 8.35742 36.656 8.43181C36.6064 8.50125 36.5618 8.57564 36.5122 8.65004C36.4626 8.72939 36.413 8.81371 36.3684 8.89802C36.3287 8.97242 36.284 9.05178 36.2493 9.13113C36.2047 9.22537 36.165 9.3196 36.1253 9.41383C36.0906 9.49319 36.0559 9.5775 36.0261 9.66182C35.9865 9.76597 35.9517 9.87508 35.922 9.9842C35.8972 10.0685 35.8674 10.1528 35.8476 10.2421C35.8178 10.3611 35.793 10.4901 35.7633 10.6141C35.7434 10.6984 35.7236 10.7827 35.7087 10.872C35.6839 11.0158 35.669 11.1696 35.6542 11.3233C35.6442 11.4027 35.6343 11.4771 35.6294 11.5564C35.6095 11.7945 35.5996 12.0375 35.5996 12.2954L35.8674 22.8645C35.8773 23.1968 36.1501 23.4647 36.4824 23.4647H40.1229C40.47 23.4647 40.7478 23.177 40.7379 22.8348L40.475 13.5254C40.475 12.8112 40.6387 12.1764 40.961 11.6259C41.2834 11.0753 41.7298 10.6488 42.2902 10.3413C42.8507 10.0338 43.4905 9.88004 44.2047 9.88004C44.5419 9.88004 44.909 9.90484 45.3157 9.9594C45.3653 9.96436 45.4149 9.97428 45.4595 9.97924C45.886 10.0388 46.263 9.71142 46.263 9.27992V6.43305C46.263 6.07595 45.9951 5.77341 45.643 5.72877C44.2345 5.56014 40.7131 5.33696 38.2431 6.9191Z"
              fill="#E50038" />
            <path
              d="M75.6191 6.9191C75.5794 6.9439 75.5447 6.96374 75.505 6.98854C75.4207 7.04806 75.3364 7.10757 75.2521 7.17205C75.1975 7.21173 75.1479 7.2514 75.0934 7.29108C75.019 7.3506 74.9496 7.41507 74.8801 7.47459C74.8256 7.52419 74.766 7.57378 74.7115 7.62834C74.647 7.69282 74.5875 7.75729 74.523 7.82177C74.4685 7.88128 74.4089 7.94576 74.3544 8.00528C74.2998 8.06975 74.2453 8.13919 74.1907 8.21358C74.1362 8.28302 74.0866 8.35742 74.032 8.43181C73.9824 8.50125 73.9378 8.57564 73.8882 8.65004C73.8386 8.72939 73.789 8.81371 73.7443 8.89802C73.7047 8.97242 73.66 9.05178 73.6253 9.13113C73.5807 9.22537 73.541 9.3196 73.5013 9.41383C73.4666 9.49319 73.4319 9.5775 73.4021 9.66182C73.3624 9.76597 73.3277 9.87508 73.298 9.9842C73.2732 10.0685 73.2434 10.1528 73.2236 10.2421C73.1938 10.3611 73.169 10.4901 73.1393 10.6141C73.1194 10.6984 73.0996 10.7827 73.0847 10.872C73.0599 11.0158 73.045 11.1696 73.0301 11.3233C73.0202 11.4027 73.0103 11.4771 73.0054 11.5564C72.9855 11.7945 72.9756 12.0375 72.9756 12.2954L73.2434 22.8645C73.2533 23.1968 73.5261 23.4647 73.8584 23.4647H77.4988C77.846 23.4647 78.1238 23.177 78.1138 22.8348L77.851 13.5254C77.851 12.8112 78.0146 12.1764 78.337 11.6259C78.6594 11.0753 79.1058 10.6488 79.6662 10.3413C80.2267 10.0338 80.8665 9.88004 81.5807 9.88004C81.9179 9.88004 82.285 9.90484 82.6916 9.9594C82.7412 9.96436 82.7908 9.97428 82.8355 9.97924C83.262 10.0388 83.6389 9.71142 83.6389 9.27992V6.43305C83.6389 6.07595 83.3711 5.77341 83.019 5.72877C81.6104 5.56014 78.089 5.33696 75.6191 6.9191Z"
              fill="#E50038" />
          </svg>
        </div>
      </ion-item>
      <ion-item @click="navigateToProfile"
        class="flex justify-between items-center border rounded-full p-1 mx-2 w-[90%] border-zinc-300 dark:border-zinc-400 wide"
        :class="{ primary: urlIsProfile }">
        <div :class="{ primary: urlIsProfile }" class="avatar size-9">
          <div class="size-8">
            <UserAvatar :avatar="user.avatar" />
          </div>
        </div>
        <div class="flex flex-col text-xs pb-1 pl-2">
          <p class="line-clamp-1">{{ user.name }}</p>
          <p class="text-gray-500 line-clamp-1">@{{ user.username }}</p>
        </div>
      </ion-item>

      <div v-if="userData?.current_streak > 2"
        class="streak-widget border-zinc-300 dark:border-zinc-400 text-black dark:text-white" @click="openStreakModal">
        <div class="flex flex-row items-center justify-center wip-streak" style="gap: 0.5em">
          <div class="flame">
            <!-- Use static flame in wide mode (desktop) -->
            <img :src="flameStatic" class="icon wide-flame" />
            <!-- Use animated flame in narrow mode (mobile) -->
            <img :src="flameAnimation" class="icon narrow-flame" />
            <p class="num">{{ userData ? userData.current_streak : "" }}</p>
          </div>

          <p class="title" style="margin-top: 10px">Day Streak</p>
        </div>
      </div>
      <ion-item @click="navigateToProfile" class="menu-item narrow" :class="{ primary: urlIsProfile }">
        <ion-icon class="w-10 text-3xl ion-padding-end flex-shrink-0" :icon="personCircleOutline" />
        <ion-label class="font-sf-pro font-bold text-menu leading-menu -ml-2">Profile</ion-label>
      </ion-item>
      <div v-if="!groupId || (groupId && !group.isBanned)" class="wide pb-4">
        <button v-if="!groupId || (groupId && group.isJoined)" @click="openCreatePost"
          class="bg-primary text-white py-3 p-5 rounded-full mt-2 w-full mx-2">
          Post{{ groupId && group.isJoined ? " to Group" : "" }}
        </button>
        <button v-else-if="groupId && !group.isJoined" @click="joinGroup"
          class="bg-primary text-white py-3 p-5 rounded-full mt-5 w-full mx-2">
          Join Group
        </button>
      </div>
      <ion-item class="narrow menu-item pb-4" v-if="!groupId || (groupId && !group.isBanned)" @click="openCreatePost">
        <ion-icon :icon="addCircleSharp" class="text-4xl primary" />
      </ion-item>
    </ion-list>

    <!-- Scrollable content -->
    <div class="overflow-y-auto flex-grow flex flex-col">
      <ion-list lines="none" class="cursor-pointer select-none space-y-2 menu-list list-view -ml-2">
        <ion-item @click="navigateToHome" :class="{ primary: urlIsHome }" class="menu-item">
          <ion-icon class="w-10 ion-padding-end" :src="home" />
          <ion-label class="font-sf-pro font-bold text-menu leading-menu -ml-2">Home</ion-label>
        </ion-item>

        <ion-item @click="navigateToSearch" :class="{ primary: urlIsSearch }" class="menu-item">
          <ion-icon class="w-10 ion-padding-end" :src="search" />
          <ion-label class="font-sf-pro font-bold text-menu leading-menu -ml-2">Search</ion-label>
        </ion-item>
        <ion-item @click="navigateToGroups" :class="{ primary: urlIsGroups }" class="menu-item">
          <ion-icon class="w-10 ion-padding-end" :src="groups" />
          <ion-label class="font-sf-pro font-bold text-menu leading-menu -ml-2">Groups</ion-label>
        </ion-item>
        <ion-item @click="navigateToProfile" class="menu-item wide" :class="{ primary: urlIsProfile }">
          <ion-icon class="w-10 text-3xl ion-padding-end flex-shrink-0" :icon="personCircleOutline" />
          <ion-label class="font-sf-pro font-bold text-menu leading-menu -ml-2">Profile</ion-label>
        </ion-item>
        <ion-item @click="navigateToConnections" class="menu-item" :class="{ primary: urlIsConnections }">
          <ion-icon class="w-10 ion-padding-end" :src="connectionsIcon" />
          <ion-label class="font-sf-pro font-bold text-menu leading-menu -ml-2">Connections</ion-label>
        </ion-item>
        <ion-item @click="openParlerPay" class="menu-item">
          <ion-icon class="w-10 ion-padding-end" :src="kyvoAppIcon" />
          <ion-label class="font-sf-pro font-bold text-menu leading-menu -ml-2">Wallet</ion-label>
        </ion-item>
        <ion-item @click="openPlayTv" class="menu-item">
          <ion-icon class="w-10 ion-padding-end dark:hidden" :src="playTvLight" />
          <ion-icon class="w-10 ion-padding-end hidden dark:block" :src="playTvDark" />
          <ion-label class="font-sf-pro font-bold text-menu leading-menu -ml-2">
            PlayTV
          </ion-label>
        </ion-item>
        <ion-item v-if="new Date(globalStore.timeoutExpiresAt) > new Date()" @click="navigateToViolations"
          class="text-2xl font-bold text-menu leading-menu text-red-500 menu-item"
          :class="!remainingTime && 'animate-pulse'"
          :title="`${remainingTime} remaining until your account is fully restored`">
          <ion-icon class="w-10 ion-padding-end timeout" :src="timeout" />
          <ion-label v-if="remainingTime" class="font-mono font-bold text-red-500 leading-none">{{ remainingTime
          }}</ion-label>
          <ion-label v-else class="text-menu leading-menu">Timeout</ion-label>
        </ion-item>
      </ion-list>

      <!-- Settings section -->
      <div class="mt-auto pb-4">
        <ion-list v-if="settings" lines="none" class="cursor-pointer select-none -ml-2">
          <ion-item v-if="hasViolations" @click="navigateToViolations" :class="{ primary: urlIsViolations }"
            class="menu-item">
            <ion-icon class="w-10 ion-padding-end" :src="ViolationIcon" />
            <ion-label class="font-sf-pro font-bold text-menu leading-menu -ml-2">
              Violations
            </ion-label>
          </ion-item>
          <ion-item @click="navigateToSettings" :class="{ primary: urlIsSettings }" class="menu-item">
            <ion-icon class="w-10 ion-padding-end flex-shrink-0" :icon="cog" />
            <ion-label class="font-sf-pro font-bold text-menu leading-menu -ml-2">
              Settings
            </ion-label>
          </ion-item>
          <ion-item @click="openInvite" class="menu-item">
            <ion-icon class="w-10 ion-padding-end" :icon="share" />
            <ion-label class="font-sf-pro font-bold text-menu leading-menu -ml-2">Invite</ion-label>
          </ion-item>
          <ion-item @click="openZendesk" class="menu-item">
            <ion-icon class="w-10 ion-padding-end" :src="FeedbackIcon" />
            <ion-label class="font-sf-pro font-bold text-menu leading-menu -ml-2">Feedback</ion-label>
          </ion-item>
          <ion-item v-if="isCurrentUserAdmin || isCurrentUserEmployee" @click="loginAdmin" class="menu-item">
            <ion-icon class="w-10 ion-padding-end flex-shrink-0" :icon="compass" />
            <ion-label class="font-sf-pro font-bold text-menu leading-menu -ml-2">Admin</ion-label>
          </ion-item>
          <ion-item @click="openKnowledgeCenter()" class="menu-item">
            <ion-icon class="w-10 ion-padding-end flex-shrink-0" :icon="helpCircleOutline" />
            <ion-label class="font-sf-pro font-bold text-menu leading-menu -ml-2">Help Center</ion-label>
          </ion-item>
          <ion-item class="menu-item" @click="toggleDarkMode">
            <ion-icon v-if="!dark_mode" class="w-10 ion-padding-end flex-shrink-0" :icon="moonSharp"
              :class="{ white: dark_mode }" />
            <ion-icon v-else class="w-10 ion-padding-end flex-shrink-0" :icon="sunnySharp"
              :class="{ white: dark_mode }" />
            <ion-toggle v-model="dark_mode" class="wide" />
          </ion-item>
          <ion-item class="menu-item" @click="logout()">
            <ion-icon class="w-10 ion-padding-end flex-shrink-0" :icon="logOutSharp" />
            <ion-label class="font-sf-pro font-bold text-menu leading-menu -ml-2">Logout</ion-label>
          </ion-item>
        </ion-list>
        <div @click="toggleSettings" class="flex items-center space-x-2 p-3 menu-item">
          <div class="flex items-center justify-center space-x-1">
            <ion-icon :icon="cog" class="text-3xl text-black dark:text-white narrow" />

            <ion-label
              class="font-bold text-sm no-wrap line-clamp-1 text-black dark:text-white ml-2 cursor-pointer select-none">
              Settings & Support
            </ion-label>
            <ion-icon :icon="settings ? chevronUp : chevronDown" class="text-gray-500" />
          </div>
        </div>
        <div v-if="settings" class="flex justify-start ml-3 items-center text-black dark:text-white space-x-1"
          @click="forceRefresh">
          <ion-icon class="flex-shrink-0 text-md cursor-pointer" :icon="refresh" />
          <p class="text-[0.6rem]">build-{{ version }}</p>
        </div>
      </div>
    </div>
  </div>
  <FeedbackModal :is-opened="feedbackModalOpen" @close="feedbackModalOpen = false" @showToast="showToast" />
  <InviteModal :is-opened="inviteModalOpen" @closeInvite="inviteModalOpen = false" @showToast="showToast" />
  <create-post-popup v-if="createPostOpen" :is-opened="createPostOpen" @close="handleCreatePostPopupClose" />

  <!-- Use the StreakModal component -->
  <StreakModal :is-open="streakModalOpen" :streak-count="userData?.current_streak" @close="streakModalOpen = false" />
</template>

<script setup>
import {
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonToggle,
  toastController,
  IonModal,
  IonHeader,
  IonToolbar,
  IonButton,
} from "@ionic/vue";
import home from "@/assets/parler/home.svg";
import search from "@/assets/parler/search.svg";
import groups from "@/assets/parler/groups.svg";
import { useGlobalStore } from "../stores/global";
import { usePostStore } from "../stores/post";
import { useNotificationStore } from "../stores/notification";
import CreatePostPopup from "./CreatePostPopup.vue";
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import UserAvatar from "./UserAvatar.vue";
import { useAdminStore } from "@/stores/admin";
import { useRoute, useRouter } from "vue-router";
import FeedbackModal from "./FeedbackModal.vue";
import FeedbackIcon from "@/assets/parler/feedback_icon.svg";
import ViolationIcon from "@/assets/parler/violation_icon.svg";
import InviteModal from "./InviteModal.vue";
import {
  addCircleSharp,
  chevronDown,
  chevronUp,
  cog,
  compass,
  helpCircleOutline,
  logOutSharp,
  moonSharp,
  personCircleOutline,
  refresh,
  sunnySharp,
  closeOutline,
  flameOutline,
  ribbonOutline,
} from "ionicons/icons";
import connectionsIcon from "@/assets/connections.svg";
import parlerPay from "@/assets/parler/parler_pay.svg";
import kyvoAppIcon from "@/assets/parler/kyvo_app_icon.svg";
import parlerNews from "@/assets/parler_news.svg";
import playTvLight from "@/assets/parler/playtv_light.svg";
import playTvDark from "@/assets/parler/playtv_dark.svg";
import share from "@/assets/parler/share.svg";
import timeout from "@/assets/parler/timeout.svg";
import { useAuthStore } from "@/stores/auth.js";
import { useUserStore } from "@/stores/users";
import flameAnimation from "@/assets/flame_animation.gif";
import flameStatic from "@/assets/flame_static.svg";
import trophy from "@/assets/trophy.svg";
import coins from "@/assets/coins.svg";
import StreakModal from "@/components/StreakModal.vue";

const props = defineProps({
  groupId: String,
});

const emit = defineEmits(["open", "openInvite", "close", "scroll-top"]);
const authStore = useAuthStore();
const globalStore = useGlobalStore();
const postStore = usePostStore();
const notificationStore = useNotificationStore();
const router = useRouter();
const route = useRoute();
const user = authStore.currentUser;
const createPostOpen = ref(false);
const showMore = ref(false);
const settings = ref(false);
const logoTimeout = ref(null);
const loading = ref(false);
const feedbackModalOpen = ref(false);
const inviteModalOpen = ref(false);
const remainingTime = ref(null);
const userStore = useUserStore();
const ulid = ref(user.ulid);

// Get user data from the store
const userData = computed(() => {
  // Find user either by ULID or by looking up all users and finding by username
  const userByUlid = userStore.users[ulid.value];

  if (userByUlid) {
    return userByUlid;
  }

  // Look through all users if not found by ULID
  const allUsers = Object.values(userStore.users);
  const userByUsername = allUsers.find((u) => u?.username === user.username);

  return userByUsername;
});

const isIOSPWA = computed(() => {
  return Boolean(window.webkit && window.webkit.messageHandlers);
});

const isAndroidPWA = computed(() => {
  return window.matchMedia("(display-mode: standalone)").matches;
});

const isApp = computed(() => {
  return isIOSPWA.value || isAndroidPWA.value;
});

const openFeedback = () => {
  feedbackModalOpen.value = true;
};

const toggleSettings = () => {
  settings.value = !settings.value;
  if (settings.value) {
    globalStore.fetchUserViolations();
  }
};

const group = computed(() => {
  return postStore.groups[props.groupId] || {};
});

const openInvite = () => {
  inviteModalOpen.value = true;
};

const showToast = async (message, color) => {
  const toast = await toastController.create({
    message,
    color,
    duration: 2000,
    position: "top",
  });
  toast.present();
};

const version = import.meta.env.VITE_APP_VERSION;

const date = import.meta.env.VITE_BUILD_DATE;

const hasViolations = computed(() => {
  return globalStore.userViolations.length > 0;
});

const isCurrentUserEmployee = computed(() => {
  return (
    authStore.currentUser.badges &&
    authStore.currentUser.badges.includes("employee")
  );
});

const isCurrentUserAdmin = computed(() => {
  return (
    authStore.currentUser.badges &&
    authStore.currentUser.badges.includes("administrator")
  );
});

const joinGroup = async () => {
  await postStore.joinGroup(props.groupId, authStore.currentUser.ulid);
};

const countUnseenNotifications = async () => {
  try {
    await notificationStore.checkNotifications();
  } catch (error) {
    console.error("Failed to fetch notification counts:", error);
  }
};

const setFeedType = () => {
  if (globalStore.settings.default_feed) {
    globalStore.currentFeed = globalStore.settings.default_feed;
  } else {
    globalStore.currentFeed = "following";
  }
};

const toggleDarkMode = () => {
  dark_mode.value = !dark_mode.value;
};

onMounted(() => {
  if (!hasViolations.value) {
    globalStore.fetchUserViolations();
  }
  if (new Date(globalStore.timeoutExpiresAt) > new Date()) {
    startCountdown(new Date(globalStore.timeoutExpiresAt));
  }

  fetchUserData();
});

onBeforeUnmount(() => {
  clearInterval(countdownInterval);
});

let countdownInterval = null;

function startCountdown(timeoutUntil) {
  countdownInterval = setInterval(() => {
    const now = new Date();
    const timeDifference = timeoutUntil - now;

    if (timeDifference <= 0) {
      clearInterval(countdownInterval);
      remainingTime.value = "00:00:00:00";
    } else {
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
      const seconds = Math.floor((timeDifference / 1000) % 60);

      const formatTime = (time) => String(time).padStart(2, "0");

      remainingTime.value = `${days > 0 ? formatTime(days) + ":" : ""
        }${formatTime(hours)}:${formatTime(minutes)}:${formatTime(seconds)}`;
    }
  }, 1000);
}

function logoClick() {
  globalStore.currentFeed = globalStore.settings.default_feed;
  // if route.path is not '/' then redirect to '/' else emit event
  if (route.path !== "/feed") {
    router.push("/feed");
    emit("scroll-top");
    return;
  }
  loading.value = true;
  countUnseenNotifications();
  emit("scroll-top");

  setFeedType();

  logoTimeout.value = setTimeout(() => {
    loading.value = false;
  }, 1000);
}

const navigateToViolations = () => {
  if (urlIsViolations.value) {
    emit("close");
    return;
  }
  router.push("/violations");
};

let activeRoute;
if (route.path === `/${user.username}`) {
  activeRoute = "profile";
} else if (route.path === `/${user.username}/connections`) {
  activeRoute = "connections";
} else if (route.path === "/settings") {
  activeRoute = "settings";
} else if (route.name === "Search" || route.name === "SearchDefault") {
  activeRoute = "search";
} else if (route.path === "/groups") {
  activeRoute = "groups";
} else {
  activeRoute = "home";
}

const navigateToSearch = () => {
  if (urlIsSearch.value) {
    emit("close");
    return;
  }
  router.push("/search");
};

const navigateToGroups = () => {
  if (urlIsGroups.value) {
    emit("close");
    return;
  }
  router.push("/groups");
};

const openStore = () => {
  window.open("https://shop.parler.com", "_blank");
};

const openParlerNews = () => {
  window.open("https://news.parler.com", "_blank");
};

const forceRefresh = () => {
  // Clear cache
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.controller.postMessage({ action: "clearCache" });
  }

  // Reload the page
  window.location.reload(true);
};

const navigateToProfile = () => {
  if (urlIsProfile.value) {
    emit("close");
    return;
  }
  const encodedUsername = encodeURIComponent(user.username);

  router.push(`/${encodedUsername}`);
};

const navigateToHome = () => {
  if (urlIsHome.value) {
    emit("close");
    return;
  }
  router.push(`/feed`);
};

const navigateToConnections = () => {
  if (urlIsConnections.value) {
    emit("close");
    return;
  }
  const encodedUsername = encodeURIComponent(user.username);

  router.push(`/${encodedUsername}/connections`);
};

const navigateToSettings = () => {
  if (urlIsSettings.value) {
    emit("close");
    return;
  }
  router.push(`/settings`);
};

const openKnowledgeCenter = () => {
  window.open("https://parler-support.zendesk.com/", "_blank");
};

const openZendesk = () => {
  window.open(
    "https://parler-support.zendesk.com/hc/en-us/requests/new ",
    "_blank"
  );
};

const openParlerStore = () => {
  window.open("https://shop.parler.com", "_blank");
};

const openParlerPay = () => {
  window.open("https://app.kyvo.io/login", "_blank");
};

const openPlayTv = () => {
  window.open("https://playtv.parler.com", "_blank");
};

const urlIsProfile = computed(() => {
  return router.currentRoute.value.path === `/${user.username}`;
});

const urlIsConnections = computed(() => {
  return router.currentRoute.value.path === `/${user.username}/connections`;
});

const urlIsSettings = computed(() => {
  return router.currentRoute.value.path === `/settings`;
});

const urlIsHome = computed(() => {
  return router.currentRoute.value.path === `/feed`;
});

const urlIsViolations = computed(() => {
  return router.currentRoute.value.path === `/violations`;
});

const urlIsSearch = computed(() => {
  return (
    router.currentRoute.value.name === `Search` ||
    router.currentRoute.value.name === `SearchDefault`
  );
});

const urlIsGroups = computed(() => {
  return router.currentRoute.value.path === `/groups`;
});

function openCreatePost() {
  createPostOpen.value = true;
}

function handleCreatePostPopupClose() {
  createPostOpen.value = false;
}

const dark_mode = computed({
  get: () => globalStore.settings.dark_mode,
  set: (value) => {
    globalStore.updateSettings("dark_mode", value);
  },
});

function loginAdmin() {
  useAdminStore().loginAdmin();
}

function logout() {
  authStore.signOut(router);
  router.push("/login");
}

const fetchUserData = async () => {
  try {
    await userStore.fetchUserByUsername(user.username, true);
  } catch (error) {
    console.error("Error fetching user data:", error);
  }
};

const streakModalOpen = ref(false);

function openStreakModal() {
  streakModalOpen.value = true;
}
</script>
<style scoped lang="scss">
@import "@/assets/styles/mixins.scss";

ion-icon .active {
  color: var(--tertiary-color);
}

.primary {
  color: var(--primary-color);
}

.bg-primary {
  background: var(--primary-color);
}

.avatar {
  padding: 2px;
  /* Border width */
  border-radius: 50%;
}

.avatar.primary {
  background: linear-gradient(to right,
      var(--primary-color),
      var(--secondary-color));
}

.avatar img {
  display: block;
  border-radius: 50%;
}

/* Common styling for both menu lists */
.menu-list {
  /* Use the same padding for icon alignment consistency */
  padding-left: 8px;
  padding-right: 4px;
}

/* Ensure consistent spacing in scrollable area */
.overflow-y-auto {
  /* Always reserve space for scrollbar to prevent layout shifts */
  scrollbar-gutter: stable;

  /* Use a consistent padding regardless of scrollbar */
  padding-right: 4px;

  /* Custom scrollbar styling to make it less intrusive */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--primary-color);
    /* Use the primary color (red) */
    border-radius: 4px;
  }

  /* For Firefox */
  scrollbar-width: thin;
  scrollbar-color: var(--primary-color) transparent;
  /* Use the primary color (red) */
}

/* Default display modes */
.narrow {
  display: none;
}

.wide {
  display: block;
  width: 90%;
}

/* Flame display modes */
.wide-flame {
  display: block;
}

.narrow-flame {
  display: none;
}

/* Streak widget styles */
.streak-widget {
  border-width: 1px;
  border-radius: 24px;
  margin: 8px;
  padding: 14px;
  width: 90%;

  .title {
    font-weight: 600;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 1px;
    vertical-align: bottom;
    text-transform: uppercase;
    margin-top: 0.25em;
  }

  .flame {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.5em;

    .icon {
      width: 32px;
      align-self: normal;
    }
  }

  .num {
    font-weight: 600;
    font-size: 32px;
    line-height: 100%;
    letter-spacing: 0px;
    vertical-align: bottom;
    text-transform: uppercase;
  }
}

/* Modal styles */
body.dark {
  .flame-icon {
    box-shadow: 0 0 30px 2px rgba(255, 255, 255, 0.25);
  }
}

.wip-streak {
  flex-direction: column;

  @include breakpoint(1010px) {
    flex-direction: row;
  }
}

/* Mobile styles */
@media (max-width: 1000px) {

  /* Hide the labels only within menu items */
  .menu-item ion-label {
    display: none;
  }

  /* Center icons within the menu items */
  .menu-item ion-icon {
    margin: 0 auto;
    padding-right: 0;
  }

  .timeout {
    animation: spin 1s linear infinite;
  }

  /* Center icons */
  .menu-item {
    justify-content: center;
    border: none;
    padding-right: 0;
  }

  .list-view {
    padding-right: 0;
  }

  /* Change display modes for mobile */
  .narrow {
    display: block;
  }

  .wide {
    display: none;
  }

  .wide-flame {
    display: none;
  }

  .narrow-flame {
    display: block;
  }

  /* Adjust streak widget for mobile */
  .streak-widget {
    border-width: 0;
    padding: 0px;
  }

  .logo-narrow {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
